import { format } from "date-fns";
import React from "react";
import { Exercise } from "../../../models/Exercise";
import "../style.scss";
import "../../../../style/block.scss";
import "../../../../style/hovers.scss";
import { BsArrowRight, BsCircle } from "react-icons/bs";
import { BiBlock } from "react-icons/bi";
import HtmlTooltip from "@mui/material/Tooltip";
import { HiOutlineTicket } from "react-icons/hi";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import { useTranslation } from "react-i18next";
import { Identifiable } from "../../../models/Identifiable";
import useCustomOffer from "../../CustomOffer/hooks/useCustomOffer";

interface IProps {
  exercise: Exercise[];
  getTicketsByExercise: (id: Identifiable, exercises: Exercise) => void;
  handleWhichClicked: (index: number) => void;
  handleCloseModal?: (boolean: boolean) => void;
  getDetailsAboutClickedExercise: (exerciseId: number) => void;
  whichClicked: number;
  onTimeSelect?: () => void;
}

const CalendarExerciseChoice: React.FC<IProps> = ({
  getDetailsAboutClickedExercise,
  exercise,
  getTicketsByExercise,
  handleCloseModal,
  handleWhichClicked,
  whichClicked,
  onTimeSelect,
}) => {
  const { t } = useTranslation();
  const { getSaleStepByStepId } = useCustomOffer();
  const foundedSaleStep = getSaleStepByStepId();

  const showTimeOfEntance = foundedSaleStep?.alwaysShowTimeToEntryInCalendarSale;
  const showTicketsPool = foundedSaleStep?.showOtherTicketsPool;

  const qntState = useSelector((state: State) => state.basket.calendarSaleQntState);

  const getQntStateCount = (itemId: string) =>
    qntState
      .filter((qntItem) => qntItem.exerciseIds === itemId)
      .reduce((total, currentItem) => total + currentItem.count, 0);

  // Handler for time selection that includes calling onTimeSelect callback
  const handleTimeSelection = (
    index: number,
    exerciseId: number,
    exerciseGroup: Identifiable,
    exerciseItem: Exercise
  ) => {
    getDetailsAboutClickedExercise(exerciseId);
    getTicketsByExercise(exerciseGroup, exerciseItem);
    handleWhichClicked(index);

    // Notify parent of time selection
    if (onTimeSelect) {
      onTimeSelect();
    }

    if (handleCloseModal) {
      handleCloseModal(false);
    }
  };

  // Sprawdzamy, czy lista ćwiczeń jest pusta
  if (!exercise || exercise.length === 0) {
    return <div className="no-available-exercises">{t("Brak dostępnych godzin")}</div>;
  }

  return (
    <>
      {exercise.map((item, index) => {
        const available = item.capacity > item.reserved + item.prereservation;
        const ticketCount = getQntStateCount(String(item.objectId));
        const timeDisplay = showTimeOfEntance ? (
          <>- {format(item.closeTime, "HH:mm")}</>
        ) : (
          showTicketsPool && (
            <div className="ticket-left flex-center-center">
              {item.capacity - (item.prereservation + item.reserved)}
              <HiOutlineTicket className="alert-icon" />
              {ticketCount > 0 && <div className="ticket-selected-count">{ticketCount}</div>}
            </div>
          )
        );

        if (available) {
          return (
            <div
              key={index}
              className={
                index === whichClicked
                  ? "active-hour-single hour-single flex-between-center flex-center-center flex-wrap move-up"
                  : "hour-single flex-between-center flex-center-center flex-wrap move-up"
              }
              onClick={() => handleTimeSelection(index, item.objectId, item.exerciseGroup, item)}
            >
              {index === whichClicked ? <BsArrowRight className="icon" /> : <BsCircle className="icon" />}
              <b className="flex-between-center">
                {format(item.startTime, "HH:mm")} {timeDisplay}
              </b>
            </div>
          );
        } else {
          return (
            <HtmlTooltip
              key={index}
              placement="right"
              title={<div className="alert alert-red">{t("wszystkie_bilety_zostaly_sprzedane")}</div>}
            >
              <div className="hour-single-disable hour-single flex-between-center flex-center-center flex-wrap">
                <BiBlock className="icon" />
                <b className="flex-between-center">
                  {format(item.startTime, "HH:mm")}{" "}
                  {showTimeOfEntance ? (
                    <>- {format(item.closeTime, "HH:mm")}</>
                  ) : (
                    <div className="ticket-left flex-center-center">
                      {item.capacity - (item.prereservation + item.reserved) > 0
                        ? item.capacity - (item.prereservation + item.reserved)
                        : 0}
                      <HiOutlineTicket className="alert-icon" />
                    </div>
                  )}
                </b>
              </div>
            </HtmlTooltip>
          );
        }
      })}
    </>
  );
};

export default CalendarExerciseChoice;
